import React from 'react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
import { m } from 'framer-motion';
export function Hero() {
  return <header className="relative overflow-hidden bg-white" data-id="element-116" data-mp="cv32tt32i8e9">
      {/* Slim brand bar */}
      <div className="border-b-[3px] border-naranja" data-id="element-117" data-mp="hvz3zyw1bgfz">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-4 py-4 sm:px-6" data-id="element-118" data-mp="hsl4cyer9lc8">
          <span className="font-heading text-lg font-bold text-azul" data-id="element-119" data-mp="ms7ozswwy3v2">🏐 Voley-Pro 360</span>
        </div>
      </div>

      <div className="relative bg-gradient-to-b from-bg-secondary to-white pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-120" data-mp="vmm49vhg1ee6">
        <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-121" data-mp="10lyp6aor8be4">
          <m.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-122" data-mp="15l1t1rt00bki">
            <SectionTag icon="🏐" data-id="element-123" data-mp="1akoa6cby6byl">Para entrenadores que quieren dejar de improvisar</SectionTag>
          </m.div>

          <m.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="mt-5 font-heading text-3xl font-bold uppercase leading-[1.15] tracking-tight text-azul sm:text-4xl md:text-5xl" data-id="element-124" data-mp="9olxq9grhynd">
            Deja de preparar cada entrenamiento desde cero
          </m.h1>

          {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
          <img src="https://cdn.magicpatterns.com/uploads/1hSP4dbiLE1qtF5VJVuZT9/ChatGPT_Image_27_ago_2026__15_25_38-removebg-preview.webp" alt="VOLEY-PRO 360 — Sistema Sesión en Mano: colección de 6 tomos y 5 bonos" width={500} height={500} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-md sm:max-w-lg" data-id="element-125" data-mp="nexr0bp323g3" />

          <m.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.18
        }} className="mt-6 max-w-2xl border-l-4 border-naranja px-4 text-left text-base leading-relaxed text-muted sm:text-lg" data-id="element-126" data-mp="16byyc3640fn7">
            Organiza tu temporada con VOLEY-PRO 360: 6 tomos, sesiones completas y 5 bonos con ejercicios,
            progresiones, diagramas y correcciones para trabajar con tu equipo.
          </m.p>

          <m.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.22
        }} className="mt-3 text-sm font-semibold text-azul" data-id="element-127" data-mp="2hxippvk35d04">
            414 páginas · 11 PDF · Acceso inmediato
          </m.p>

          <m.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.26
        }} className="mt-7 flex flex-col items-center" data-id="element-128" data-mp="2cyfkaa0714rm">
            <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-129" data-mp="1vmr146qjnnsr">
              Quiero organizar mis entrenamientos
            </PrimaryButton>
            <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-130" data-mp="1qpijq8d7znsk">
              ⚡ Acceso inmediato · 📱 Formato digital · Úsalo desde móvil, tablet u ordenador
            </p>
          </m.div>
        </div>
      </div>
    </header>;
}